module.exports = __webpack_public_path__ + "c662dc21d811fda80d5ecd6c38a3e3cf.pdf";